import { ComponentProps, FC } from 'react';
import { intrinsicClassName } from '../../utils/reactView';
import styles from './Checkbox.module.css';

const Input = intrinsicClassName('input', styles.checkbox);

export const Checkbox: FC<ComponentProps<typeof Input>> = (props) => (
  <Input {...props} type="checkbox" />
);
